

















































import { defineComponent, onMounted, reactive, toRefs, ref, watch, computed } from '@vue/composition-api';
import { userHotVideo } from '@services/share/photo';
import { getTargetUrl, formateNum } from '@common/util';
import { immediateSendLog, sendLog, radarLog } from '@common/log';
import { webBucket } from '@common/const';
import cookies from 'js-cookie';
import Dialog from 'vant/lib/dialog';
import '../../dialog.css';

export default defineComponent({
    components: {
        vanDialog: Dialog.Component,
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['closeDialog'],
    setup(props, { root, emit }: any) {
        const {
            initData: { kpn, isRtl, photoId, params, query, isSupportWebp, shareUserInfo },
            message: {
                localLang,
                pageConf: { photoDialog },
            },
        } = root.$store.state;

        const playStopStatus = computed(() => {
            return root.$store.state.photoPageModule?.playStopStatus || 'PLAYED';
        });

        const confirmButtonText = localLang.share_photo_popup_yes || 'OK';
        const cancelButtonText = localLang.share_photo_popup_no || 'Cancel';
        const fid = (Array.isArray(query.fid) ? query.fid[0] : query.fid) as string;

        // const currentExp = photoDialog?.exp;
        const currentExp = 'exp5';
        const logoUrl = photoDialog?.logoUrl || '//cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/s1/i/def/head_m.png';
        const theme = 'round-button-ab';

        const dialogTitle = computed(() => {
            let content = playStopStatus.value === 'PLAYED' ? photoDialog?.title : localLang.share_photo_popup_playing;

            switch (kpn) {
                case 'KWAI_BULLDOG':
                    content = content?.replace(/Kwai/g, 'SnackVideo');
                    break;
                default:
                    content = content?.replace(/SnackVideo/g, 'Kwai');
            }
            return content;
        });
        
        const deviceId = (cookies.get('_did') || '') as string;
        const showMiddleDialog = ref(props.showDialog);
        const state = reactive({
            swiperVideo: [],
            currentShareVideo: {},
            firstTrendingVideo: {},
            fid,
        });

        const standByBackgroundImg = index => {
            return `https://cdn-static.kwai.net/kos/s101/nlav11312/share_popup_standBy_pic/standbyPic_${  index + 1  }.png`;
        };

        const imgBaseBucket = () => {
            if (['egy', 'pak', 'in'].indexOf(webBucket) !== -1) {
                return webBucket === 'in' ? require('../../imgs/snack_dialog.png') : require('../../imgs/me_dialog.png');
            }

            return require('../../imgs/pro_dialog.png');
        };

        const addClass = index => {
            if (index === 0) {
                return 'left';
            }
            if (index === 2) {
                return 'right';
            }
            return 'other';
        };

        const jumpApp = (area: string, photoid?: string) => {
            const logConfig: any = {
                type: 'click',
                name: 'WATCH_WITH_KWAI_POPUP_BUTTON',
                value: {
                    button_name: area === 'dialog' ? 'OK' : 'PIC',
                    trigger_scene: playStopStatus.value,
                },
            };
            // exp7是命中大v实验，跳转大v个人页
            const uid = shareUserInfo.userProfile?.profile?.user_id;
            const scheme = area === 'popup_profile_picture' && uid ? `profile/${uid}` : `work/${photoid || photoId}`;

            root.$store.commit('jumpApp', {
                logConfig,
                area,
                scheme,
            });
        };

        const handleConfirm = () => {
            emit('closeDialog');
            jumpApp('dialog', photoId);
        };

        const handleCancel = () => {
            emit('closeDialog');
            immediateSendLog({
                type: 'click',
                name: 'WATCH_WITH_KWAI_POPUP_BUTTON',
                value: {
                    button_name: 'CANCEL',
                    trigger_scene: playStopStatus.value,
                },
            });
            radarLog({
                name: 'SHARE_PHOTO_CLICK_COUNT',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: '点击WATCH_WITH_KWAI_POPUP_BUTTON, CANCEL次数',
                src: window.location.pathname,
            });
        };

        const getCoverUrl = (item: any) => {
            let resultUrl = null;
            if (isSupportWebp && item.coverWebpUrls?.length && item.coverWebpUrls[0].url) {
                resultUrl = item.coverWebpUrls[0].url;
            } else {
                resultUrl = item.coverUrls[0].url;
            }
            return resultUrl;
        };

        const getOneCoverUrl = (item: any) => {
            // 封面兜底逻辑，分桶
            let standByPic = 'https://cdn-static.kwai.net/kos/s101/nlav11312/share_popup_standBy_pic/standbyPic_2.png';
            if (['egy', 'pak', 'in'].indexOf(webBucket) !== -1) {
                standByPic =
                    webBucket === 'in'
                        ? 'https://cdn-static.kwai.net/kos/s101/nlav11312/share_popup_standBy_pic/standbyPic_3.png'
                        : 'https://cdn-static.kwai.net/kos/s101/nlav11312/share_popup_standBy_pic/standbyPic_1.png';
            }
            if (currentExp === 'exp5' && JSON.stringify(state.currentShareVideo) !== '{}') {
                return getCoverUrl(state.currentShareVideo) || standByPic;
            }
            return standByPic;
        };

        const recommentList = computed(() => {
            return root.$store.state.photoPageModule?.recommentList || [];
        });

        watch(
            () => props.showDialog,
            value => {
                showMiddleDialog.value = value;
            }
        );

        onMounted(async () => {
            try {
                const res = await userHotVideo({
                    photoId,
                    authorId: params.authorId,
                    kpn: kpn || query.kpn,
                    source: query.source,
                    source_type: query.source_type,
                    bkt: query.bkt,
                });
                const { datas } = res || {};
                if (datas?.length) {
                    const tempSwiperVideo = datas.filter((item, index) => (item.coverWebpUrls || item.coverUrls));
                    const resArr = tempSwiperVideo.slice(0, 3);
                    const currentShareVideo = resArr.shift();
                    resArr.splice(1, 0, currentShareVideo);
                    state.swiperVideo = resArr;
                    state.currentShareVideo = currentShareVideo;
                }
            } catch (error) {
                console.error(error);
                state.swiperVideo = [];
            }
        });

        return {
            showMiddleDialog,
            handleConfirm,
            handleCancel,
            getCoverUrl,
            formateNum,
            currentExp,
            getTargetUrl,
            getOneCoverUrl,
            imgBaseBucket,
            dialogTitle,
            theme,
            logoUrl,
            addClass,
            isRtl,
            standByBackgroundImg,
            ...toRefs(state),
            confirmButtonText,
            cancelButtonText,
            playStopStatus,
            jumpApp,
        };
    },
});
